import Primary from "../layouts/Primary";
import {useAsset} from "../../AssetHelper";

import {ReactSVG} from "react-svg";

import "./Randomization.css";
import {DisplayCommand, Randomize, ScoreUpdate, ShowRandom} from "../../javaTypes";
import {DisplayConfig} from "../Config";
import { t } from "../../i18n";
import OneThird from "../layouts/OneThird";
import PrimaryMatch from "../layouts/PrimaryMatch";

const randomizationLabel = {
    [1]: `MOTIF 1 (ID 21)`,
    [2]: `MOTIF 2 (ID 22)`,
    [3]: `MOTIF 3 (ID 23)`
}

export function RandomizationArtifacts({number} : {number: 1 | 2 | 3}) {
    const greenArtifact = useAsset(`img/decode/artifact-green.svg`)
    const purpleArtifact = useAsset(`img/decode/artifact-purple.svg`)

    const artifacts = {
        [1]: [greenArtifact, purpleArtifact, purpleArtifact],
        [2]: [purpleArtifact, greenArtifact, purpleArtifact],
        [3]: [purpleArtifact, purpleArtifact, greenArtifact]
    }[number];

    return <div className={"artifacts"}>
        {artifacts.map((artifact, index) => (
            <ReactSVG key={index} src={artifact} className={`artifact artifact-${index + 1}`}/>
        ))}
    </div>
}

export default function Randomization({command, scoreUpdate, config} : {
    command: DisplayCommand<Randomize | ShowRandom>,
    scoreUpdate?: DisplayCommand<ScoreUpdate>,
    config: DisplayConfig
}) {
    // This should never be possible, but don't crash if it happens
    if(!scoreUpdate) {
        return <div>No score data. Cannot display randomization.</div>;
    }
    const number = scoreUpdate.params.rand as 1 | 2 | 3;
    const vflip = config.scoringBarLocation === 'top';
    const overlay = config.overlay;

    const randomWrapper = <div className={`randomizationWrapper random-${number} `}>
        <RandomizationArtifacts number={number} />
        <span className={"positionSpan"}>{randomizationLabel[number]}</span>
    </div>;
    if (!overlay) {
        return <PrimaryMatch pageTitle={command.params.matchName} pageName={t`Randomization`} config={config}>
            <div className={"randomizationPanel"}>
                {randomWrapper}
            </div>
        </PrimaryMatch>;
    } else {
        return <div className={`h-100 w-100 randomizationPage`}>
            <div className={`chroma ${vflip ? "vflip" : ""}`} style={{backgroundColor: `${config.overlayColor}`}}/>
            <OneThird matchName={command.params.matchName} vflip={vflip}>
                <div className={"randomizationPanel"}>
                    {randomWrapper}
                </div>
            </OneThird>
        </div>
    }

}